import { fetchApi } from './api';
import type { WeeklyArApBalance, CreateWeeklyArApData, UpdateWeeklyArApData } from '../types/bankBalance';

export const weeklyArApApi = {
    list: (companyCode: string, year?: number) => {
        const p = new URLSearchParams({ companyCode });
        if (year) p.set('year', String(year));
        return fetchApi<WeeklyArApBalance[]>(`/weekly-arap?${p}`);
    },
    create: (data: CreateWeeklyArApData) =>
        fetchApi<{ id: number }>('/weekly-arap', { method: 'POST', body: JSON.stringify(data) }),
    update: (id: number, data: UpdateWeeklyArApData) =>
        fetchApi<{ id: number }>(`/weekly-arap/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id: number) =>
        fetchApi<{ id: number }>(`/weekly-arap/${id}`, { method: 'DELETE' }),
    copyLastWeek: (companyCode: string, targetDate: string) =>
        fetchApi<{ id: number }>('/weekly-arap/copy-last-week', {
            method: 'POST',
            body: JSON.stringify({ companyCode, targetDate }),
        }),
};
